const VARIANTS = {
  admin: "border-0 bg-brand-gradient text-white",
  member: "bg-slate-100 text-slate-600 border-slate-200",
  active: "bg-emerald-50 text-emerald-600 border-emerald-200",
  disabled: "bg-red-50 text-red-600 border-red-200",
  locked: "bg-accent-50 text-accent-700 border-accent-200",
};

export default function Badge({ variant = "member", icon, children }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-medium ${
        VARIANTS[variant] || VARIANTS.member
      }`}
    >
      {icon}
      {children}
    </span>
  );
}
